import { queryOptions } from '@tanstack/react-query';
import { AxiosResponse } from 'axios';

import {
    IPurchaseChartInfoData,
    IPurchaseChartInfoDataResponseDTO,
} from '@entities/purchase/model/index.types';
import { $api } from '@shared/api';
import { keysToCamel } from '@shared/helpers/snakeToCamel';
import { IDataResponse } from '@shared/model/types/dataResponse.inteface';

// @ts-ignore
const purchaseChartInfoUrl = routable.getRoute('getPurchaseChartInfo');

export const purchasesApi = {
    getPurchaseChartInfo: async (
        { signal }: { signal: AbortSignal },
        estimateId: string
    ): Promise<AxiosResponse> => {
        const formattedUrl = purchaseChartInfoUrl.replace('_estimateId_', estimateId);
        return $api(`${formattedUrl}`, { signal });
    },
    getPurchaseChartInfoQueryOptions: ({ estimateId }: { estimateId: string }) =>
        queryOptions({
            queryKey: ['purchaseChartInfo', 'data', estimateId],
            queryFn: (meta) =>
                purchasesApi.getPurchaseChartInfo({ signal: meta.signal }, estimateId),
            select: (data) =>
                // console.log('dataDTO: ', data.data);
                keysToCamel<IDataResponse<IPurchaseChartInfoDataResponseDTO>>(
                    data?.data?.data
                ) as unknown as IPurchaseChartInfoData,
        }),
};
